import {Language} from '../ts/customTypes';
import {Pages} from '../ts/customTypes';

// Background

// Icons
import IconBenefits from '../icons/content/benefits.svg';

// Content Images
import processStepTeileidentifikation1Svg from '../content/en/process-parts-identification-step1.svg';
import processStepTeileidentifikation2Svg from '../content/en/process-parts-identification-step2.svg';
import processStepTeileidentifikation3Svg from '../content/en/process-parts-identification-step3.svg';
import processStepTeileidentifikation4Svg from '../content/en/process-parts-identification-step4.svg';

import processStepLagerergaenzung1Svg from '../content/en/process-storage-step1.svg';
import processStepLagerergaenzung2Svg from '../content/en/process-storage-step2.svg';
import processStepLagerergaenzung3Svg from '../content/en/process-storage-step3.svg';
import processStepLagerergaenzung4Svg from '../content/en/process-storage-step4.svg';

import contactImage from '../content/mail-contact.png';
import testimonial1 from '../content/testimonial1.jpg';
import testimonial2 from '../content/testimonial2.jpg';
import {IconBestellschnittstelle} from '../../lib/components/content/IconBestellschnittstelle';
import {IconKatalogschnittstelle} from '../../lib/components/content/IconKatalogschnittstelle';
import {IconVerfuegbarkeitsschnittstelle} from '../../lib/components/content/IconVerfuegbarkeitsschnittstelle';
import {IconNettopreisschnittstelle} from '../../lib/components/content/IconNettopreisschnittstelle';

import landingpageSmallImage1 from '../content/landingpage-img-1.webp';
import landingpageSmallImage2 from '../content/landingpage-img-2.webp';
import landingpageBigImage from '../content/image-landingpage-big.jpg';

import imageKatalogschnittstelle from '../content/image-katalogschnittstelle.jpg';
import imageBestellschnittstelle from '../content/image-bestellschnittstelle.jpg';
import imageNettopreisschnittstelle from '../content/image-nettopreisschnittstelle.jpg';
import imageVerfuegbarkeitsschnittstelle from '../content/image-verfuegbarkeitsschnittstelle.jpg';
import flag from '../flags/flag-en.svg';

export const en: Language = {
    id: 'EN',
    languageName: 'English',
    flagUrl: flag,
    headerHeading: 'eProcurement',
    backToLandingPageLabel: 'Overview',
    infolayer: {
        text: (
            <>
                <p>We are delighted that you would like to find out more about OMNIplus eProcurement interfaces.</p>
                <p>
                    The website has been optimised for desktop computers or tablets. Unfortunately, it is not compatible
                    with your mobile device.
                </p>
                <p>
                    You can also open the content on other end devices using the URL of this page. Simply send the
                    address of this page to a tablet or computer. Click the following link to copy the URL to the
                    clipboard:
                </p>
            </>
        ),
        button: 'Copy link to clipboard',
    },
    [Pages.LANDINGPAGE]: {
        headline: 'Procurement process',
        headlineWidth: 470,
        buttonContact: 'Contact',
        buttonTestimonials: 'Customer feedback',
        tooltips: {
            availability: 'Availability \ninterface',
            catalogue: 'Catalogue \ninterface',
            identification: 'Parts identification',
            order: 'Order interface',
            price: 'Net price \ninterface',
            storage: 'Disposition of known \nspare parts',
        },
        background: '',
        images: {
            leftUpper: landingpageSmallImage1,
            leftLower: landingpageSmallImage2,
            big: landingpageBigImage,
        },
    },
    testimonialsPage: {
        headline: 'Customer feedback',
        headlineWidth: 420,
        testimonials: [
            {
                name: 'Jens-Uwe Mentel',
                imageUrl: testimonial1,
                job: 'Technical staff member at Usedomer Bäderbahn GmbH',
                quotes: [
                    '"Setting up of the new interface to COSware has worked well. This makes it possible for us to now add spare parts to the system and order them more efficiently."',
                ],
            },
            {
                name: 'Mirano Bitici',
                job: 'Head of Purchasing at Stuttgarter Straßenbahnen AG',
                quotes: [
                    '"In a very short time, a project was set up to connect our procurement system to OMNIplus."',
                    '"The pragmatic and results-driven approach is particularly noteworthy."',
                    '“Today, we here in Procurement and at our workshops are benefiting from the reduced procurement costs.”',
                ],
            },
            {
                name: 'Richard Schallmoser',
                imageUrl: testimonial2,
                job: 'Purchasing department at Holding Graz - Kommunale Dienstleistungen GmbH',
                quotes: [
                    '"Thanks to the implementation, we have also optimised the procurement process within the environment. This added value was just as important to us as the interfaces themselves."',
                    '“Within a very short period of time, the connection has proved so successful that it has become indispensable.”',
                ],
            },
        ],
        footer: {
            headline: 'Our interfaces are used at:',
            companies: [
                'Stuttgarter Straßenbahnen AG',
                'Holding Graz – Kommunale Dienstleistungen GmbH',
                'Regionalbus Leipzig GmbH',
                'Usedomer Bäderbahn GmbH',
                'EBS Public Transportation B. V.',
            ],
        },
    },
    contactPage: {
        headline: 'Contact',
        headlineWidth: 250,
        texts: [
            'The focus is on your processes when implementing eProcurement interfaces: that’s why we support you in your customer-specific connection project for digitising your procurement.',
            'Feel free to contact us at: \n',
        ],
        email: 'omniplus-eprocurement@daimlertruck.com',
        imageUrl: contactImage,
        stepsHeadline: 'Typically, each connectivity project involves four steps:',
        steps: ['Kick-off', 'Concept development', 'Implementation', 'Go-live'],
        text: (
            <p>
                After having made contact, a kick-off will determine how eProcurement can potentially support you in
                your procurement process. Then, in the concept development phase, we analyse how this can be implemented
                and how complex or costly this is. Once the testing phase has been completed successfully, you can
                switch to the new procurement process.
            </p>
        ),
    },
    infoPages: {
        [Pages.VERFUEGBARKEITSSCHNITTSTELLE]: {
            headline: 'Availability interface',
            icon: <IconVerfuegbarkeitsschnittstelle/>,
            intro: 'View the availability of your disposed spare parts directly in your own system via the interface.',
            text: (
                <p>
                    Use the availability interface to view the current stock status for your required spare parts. You
                    can not only view the availability at your OMNIplus service centre, but also throughout the entire
                    supply chain.
                </p>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Advantages for you',
                    list: [
                        'Complete transparency regarding parts availability at your OMNIplus service centre',
                        'Shows availability throughout the entire logistics chain',
                        'Improved planning in the procurement process',
                        'Access with REST API interface',
                    ],
                },
            ],
            images: {
                main: imageVerfuegbarkeitsschnittstelle,
            },
        },
        [Pages.BESTELLSCHNITTSTELLE]: {
            headline: 'Order interface',
            icon: <IconBestellschnittstelle/>,
            intro: 'Send orders to OMNIplus directly.',
            text: (
                <p>
                    By integrating an order interface it is possible to directly transfer orders to the OMNIplus system.
                    This means that there is no system switch when ordering in the customer system. There is no need to
                    manually transfer order contents, hence the order is processed faster and precisely as transmitted.
                    The link via an interface can currently be established to Daimler Buses’ own service centres with
                    BusWorld classification.
                </p>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Advantages for you',
                    list: [
                        'Digital spare parts procurement without system switches',
                        'Faster processing of the order thanks to direct order creation in Daimler Buses Services Center',
                        'Order confirmations can be sent via the interface',
                        'Multiple connections: Connection possible on the basis of EDI standards, cXML or a REST API interface',
                    ],
                },
            ],
            images: {
                main: imageBestellschnittstelle,
            },
        },
        [Pages.KATALOGSCHNITTSTELLE]: {
            headline: 'Catalogue interface',
            icon: <IconKatalogschnittstelle/>,
            intro: 'Easy identification of the required spare parts without having to leave your system.',
            text: (
                <p>
                    Spare parts can be identified in the OMNIplus eShop via a catalogue interface and transferred to
                    your system. The OMNIplus eShop catalogue shows your customer-specific prices and the availability
                    at your OMNIplus service centre.
                </p>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Advantages for you',
                    list: [
                        'Integration of customer-specific fleets in OMNIplus eShop',
                        // #BP2-Vorteile-Katalogschnittstelle-eProcurement-Click-Explainer#
                        'Instantly see availability and pricing',
                        'Spare parts search in four different ways, for example using the vehicle documentation in the BusParts Catalog',
                        'Supports OCI and cXML standard',
                    ],
                },
            ],
            images: {
                main: imageKatalogschnittstelle,
            },
        },
        [Pages.NETTOPREISSCHNITTSTELLE]: {
            headline: 'Net price interface',
            icon: <IconNettopreisschnittstelle/>,
            intro: 'Directly view your customer-specific spare part prices in your customer system via the interface.',
            text: (
                <>
                    <p>
                        Using the net price interface, you can directly transfer the prices for your spare parts from
                        the OMNIplus system to your customer system. Your customer-specific conditions and special
                        promotions are taken into account. You can request prices from all Daimler Buses’ own service
                        centres with BusWorld classification.
                    </p>
                </>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Advantages for you',
                    list: [
                        'Prices are displayed, taking into account your individual conditions for the disposed spare parts',
                        'Complete price transparency even with promotional prices and scaled discounts',
                        'Complete ordering and approval process possible in your own system',
                        'Access with REST API interface',
                    ],
                },
            ],
            images: {
                main: imageNettopreisschnittstelle,
            },
        },
    },
    processPages: {
        [Pages.TEILEIDENTIFIKATION]: {
            headline: 'Parts identified by catalogue interface',
            headlineWidth: 780,
            infoBox: {
                headline: 'Use Case',
                bullets: [
                    "Are you looking for a spare part for your vehicle, but don't know the part number you need to use for the order? For instance, because you are dealing with a new vehicle model or the required spare part has not been stored in your own database?",
                ],
            },
            steps: [
                {
                    imageUrl: processStepTeileidentifikation1Svg,
                    headline: 'Accessing the OMNIplus eShop catalogue',
                    content: (
                        <>
                            The OMNIplus eShop catalogue can be accessed within your own ERP system to start spare parts
                            identification.
                        </>
                    ),
                },
                {
                    imageUrl: processStepTeileidentifikation2Svg,
                    headline: 'Parts identification in OMNIplus eShop',
                    content: (
                        <>
                            In the eShop interface, the required spare part can be identified in four different ways. In
                            addition to the integration of the individual fleet, the eShop, for instance, also offers a
                            spare parts search on the basis of vehicle documentation in the BusParts Catalog.
                        </>
                    ),
                },
                {
                    imageUrl: processStepTeileidentifikation3Svg,
                    headline: 'Transfer to customer system',
                    content:
                        'After having identified the required spare parts and compiled a shopping basket, the parts information can be transferred from the OMNIplus eShop to the customer system.',
                },
                {
                    imageUrl: processStepTeileidentifikation4Svg,
                    headline: 'Ordering from the customer system', // #AB4-Disposition-eProcurement-Click-Explainer#
                    content: (
                        <>
                            With one click, your order is sent to the OMNIplus system via the order interface and can be
                            directly processed.
                        </>
                    ),
                },
            ],
        },
        [Pages.LAGERERGAENZUNG]: {
            headline: 'Availability of spare parts using current stock status and price interface',
            headlineWidth: 1210,
            infoBox: {
                headline: 'Use Case',
                bullets: [
                    'In many cases, you already know which spare parts you need.',
                    'For instance, this is the case if the spare parts are already identified at the workshop and a purchase order with the required part numbers is created in your system.',
                    <>
                        Alternatively, you receive a notification in your ERP system that individual parts have reached
                        the minimum stock level. If your supplier number already exists in the master database, you can
                        then initiate a stock replenishment.
                    </>,
                ],
            },
            steps: [
                {
                    imageUrl: processStepLagerergaenzung1Svg,
                    headline: 'Disposition of spare parts to be procured', // #AB1-Disposition-eProcurement-Click-Explainer#
                    content:
                        'In your ERP system, you can place the required spare parts in a purchase order, for example to stock up.',
                },
                {
                    imageUrl: processStepLagerergaenzung2Svg,
                    headline: 'Viewing availability and price',
                    content: (
                        <>
                            After having created a purchase order in your customer system with the spare parts to be
                            procured, you can view associated availabilities and prices using the eProcurement
                            interface.
                        </>
                    ),
                },
                {
                    imageUrl: processStepLagerergaenzung3Svg,
                    headline: 'Checking the purchase order',
                    content:
                        'In your own system, you can display the information requested about the availability of common spare parts and, if necessary, initiate your internal approval processes.',
                },
                {
                    imageUrl: processStepLagerergaenzung4Svg,
                    headline: 'Ordering from the customer system',
                    content:
                        'You can then transfer your order to the OMNIplus system via the order interface so that it can be directly processed.',
                },
            ],
        },
    },
};
